import React, { useState, useEffect } from 'react';

import './styles.css';

import classServices from '../../../../../services/academy/classServices';
import coachServices from '../../../../../services/academy/coachServices';

import compare from '../../../../../functions/compare';

import { Dots } from "react-activity";

import Popup from '../../../../../components/Popup';
import SelectGroup from '../../../../../components/SelectGroup';
import Notice from '../../../../../components/Notice';
import { FaUsers } from 'react-icons/fa';

function PopupClassLink(props) {
    const [selectList, setSelectList] = useState([]);
    const [hideList, setHideList] = useState([]);
    const [classes, setClasses] = useState([]);
    const [updating, setUpdating] = useState(false);

    useEffect(() => {
        readClasses();
    }, []);

    useEffect(() => {
        let coachClasses = [];
        if (props.coachClasses) coachClasses = props.coachClasses.map(item => item.id);
        setHideList(classes.map((item, index) =>
            (item.numero_vagas - item.numero_alunos > 0 && !coachClasses.includes(item.id)) ? -1 : index)
            .filter((item) => item !== -1)
        );
    }, [props.coachClasses, classes]);

    async function readClasses() {
        const response = await classServices.getClasses();
        if (response.status === 200) {
            setClasses(response.data
                .sort((a, b) => compare(a.nome, b.nome))
                .sort((a, b) => compare(a.numero_alunos, b.numero_alunos))
                .sort((a, b) => compare(Number(a.faixa_etaria.substring(4)), Number(b.faixa_etaria.substring(4))))
            );
        } else
            alert("Erro ao ler turmas, tente novamente!");
    };

    async function linkCoachClass() {
        if (selectList.length) {
            setUpdating(true);
            let classesIds = selectList.map(item => classes[item].id);
            const response = await coachServices.postLinkCoachClasses(props.coachId, classesIds);
            setUpdating(false);
            if (response.status === 200) {
                if (props.onLink) props.onLink();
                setSelectList([]);
                props.setVisibility(false);
            } else
                alert("Erro ao vincular turma a professor, tente novamente!");
        } else
            alert("Escolha uma turma para vincular o professor.");
    };

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaUsers />}
            tittle='Vincular turma'
        >
            {
                classes.length ?
                    <>
                        <SelectGroup
                            hides={hideList}
                            markeds={selectList}
                            setMarkeds={setSelectList}
                        >
                            {
                                classes.map((item, index) =>
                                    <div key={item.id} className='select-group-coach-class-change'>
                                        <div className='select-group-coach-class-change-tittle'>
                                            <p className='tittle'>{item.nome}</p>
                                            <span className='tag small dark-blue'>{item.numero_alunos} {item.numero_alunos === 1 ? "aluno" : "alunos"}</span>
                                        </div>
                                        <p>{`${item.faixa_etaria} - ${item.tipo}`}</p>
                                    </div>
                                )
                            }
                        </SelectGroup>
                        <button
                            type='button'
                            // onClick={() => {
                            //     console.log(selectList);
                            //     console.log(selectList.map(item => classes[item].nome));
                            // }}
                            onClick={() => updating ? alert("Um envio já está em andamento.") : linkCoachClass()}
                        >
                            {
                                updating ?
                                    <Dots />
                                    : "Vincular"
                            }
                        </button>
                    </>
                    : <Notice>Não há turmas disponíveis para vinculação</Notice>
            }
        </Popup>
    )
}

export default PopupClassLink;